import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Alert, Container } from 'reactstrap';

import UiContent from '../../../../Components/Common/UiContent';

const selectEstablishmentActive = createSelector(
	state => state.Profile,
	profile => ({ establishmentActive: profile.establishmentActive }),
);

/**
 * Ruta sin `:establishmentId`: redirige al centro seleccionado globalmente (patrón PPE).
 */
const RespelStockHub = () => {
	const navigate = useNavigate();
	const { establishmentActive } = useSelector(selectEstablishmentActive);

	useEffect(() => {
		const id = establishmentActive?.item?._id;
		if (id) {
			navigate(`/residue/respel/stock/${id}`, { replace: true });
		}
	}, [establishmentActive, navigate]);

	return (
		<>
			<UiContent />
			<div className='page-content'>
				<Container fluid className='pt-3'>
					<Alert color='warning' className='mb-0'>
						Seleccione un establecimiento en la barra superior para ver el stock
						RESPEL.
					</Alert>
				</Container>
			</div>
		</>
	);
};

export default RespelStockHub;
